import React, { Component } from "react";
import DateFnsUtils from "@date-io/date-fns";
import enLocale from "date-fns/locale/es";
import {
    MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
//import { isToday } from "date-fns/esm";


export default class DateOfBirthDatePickerInline extends Component {

  constructor(props){
    super(props);

    this.state={
      locale:"es",
      minDate: this.formatDateInitial(props.arrDatePass) ,  
      localeMap:{es:enLocale},     
      selectedDate: (props.defaultValue !== null) ? props.defaultValue : null,      
      errorText:'',
			error:props.error
    }
    if(props.callbackValue) props.callbackValue(this.state.selectedDate)
  }
    
  formatDate = (date) =>{
    let d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let  day =  '' + d.getDate();
    let  year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;
  
		if([year, month, day].join('/') === 'NaN/NaN/NaN')
			return false;
		else
			return [year, month, day].join('/');
  	}


    formatDateInitial = (date) =>{
      let d = new Date(date);
      //sumo dos dias a la fecha
      d.setDate(d.getDate() + 2);
      //formato de salida para la fecha
      return d.getFullYear() + '/' + ("0" + (d.getMonth() + 1)).slice(-2) + '/' + ("0" + d.getDate()).slice(-2);
      
  	}
    
      componentDidUpdate(prevProps,prevState) {
		if (prevProps != this.props){
			if(this.props.initial !== undefined && this.props.initial){
				this.setState({ error: this.props.error, errorText:'', selectedDate:this.props.defaultValue});
			}else{
				this.setState({ error: this.props.error});
			}
		}
    } 


    handleChange = date => {
		let response = this.formatDate(date);
		this.setState({selectedDate:response})
		if(!response || date === null){
			
			this.setState({selectedDate:null,errorText: 'Ingrese una fecha con formato DD/MM/AAAA',error:true});	
		}else{
			if( response < this.state.minDate )this.setState({error:true,  selectedDate:null, errorText:"Fecha fuera de rango"});
				else
					this.setState({errorText: '',selectedDate:response,error:false});
		
		}  
   };
   

  render(){
    const {label,name,placeholder,id}=this.props
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={this.state.localeMap[this.state.locale]}>

        <KeyboardDatePicker
            //disableToolbar
            variant="inline"
            inputVariant="outlined"
            format="dd/MM/yyyy"
            label={label}
            name={name}
            minDateMessage="La fecha no debe ser anterior a la fecha llegada"
            minDate={this.state.minDate}
            value={this.state.selectedDate}
            onChange={(date) =>{this.handleChange(date)}}
            placeholder={placeholder}
            id={id}
            openTo="year" 
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            autoOk='true'
            onKeyDown="return false" 
            className={`InputForm datepicker`} 
            disabled={this.props.disabled}
            autoComplete="off" 
            InputLabelProps={{ shrink: true }}
            error={this.state.error}
		      	helperText={this.state.errorText}
          	invalidDateMessage={this.state.errorText} 
           
        />
        
      </MuiPickersUtilsProvider>
    )
  }
}